// Mirror of App\Enums\EventSplitKind (campdraftone-api) — `split_kind` field, e.g. on
// EventNominationsDashboardResource. Not backed by a single DB column (derived from
// parent_id/brother_id/is_conjunction/children_count, see Event::splitKind()). Keep in sync by
// hand; there is no shared source of truth across the two repos. No labels here — this enum has
// none on the backend either, it's an internal classification, not something shown verbatim.
export const EVENT_SPLIT_KIND_NONE = 'none'
export const EVENT_SPLIT_KIND_REGULAR_SPLIT = 'regular_split'
export const EVENT_SPLIT_KIND_COMBINED_UNSPLIT_PARENT = 'combined_unsplit_parent'
export const EVENT_SPLIT_KIND_COMBINED_UNSPLIT_CHILD = 'combined_unsplit_child'
export const EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_CONTAINER = 'combined_conjunction_container'
export const EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_CHILD = 'combined_conjunction_child'
export const EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_FINAL = 'combined_conjunction_final'
export const EVENT_SPLIT_KIND_COMBINED_SPLIT_SIDE_PARENT = 'combined_split_side_parent'
export const EVENT_SPLIT_KIND_COMBINED_SPLIT_SIDE_CHILD = 'combined_split_side_child'



// WEBPACK FOOTER //
// ./src/constants/eventSplitKind.js